<script setup lang="ts">
export interface BreadcrumbItem {
  label: string
  href?: string
}

defineProps<{
  items: BreadcrumbItem[]
}>()
</script>

<template>
  <nav class="breadcrumbs" aria-label="Nawigacja okruszkowa">
    <div class="breadcrumbs__inner container">
      <ol class="breadcrumbs__list">
        <li
          v-for="(item, i) in items"
          :key="i"
          class="breadcrumbs__item"
        >
          <span v-if="i > 0" class="breadcrumbs__sep" aria-hidden="true">/</span>
          <NuxtLink
            v-if="item.href"
            :to="item.href"
            class="breadcrumbs__link"
          >{{ item.label }}</NuxtLink>
          <span
            v-else
            class="breadcrumbs__current"
            aria-current="page"
          >{{ item.label }}</span>
        </li>
      </ol>
    </div>
  </nav>
</template>

<style scoped>
.breadcrumbs {
  background: var(--color-white);
  border-bottom: 1px solid var(--color-border);
}

.breadcrumbs__inner {
  display: flex;
  align-items: center;
  height: 44px;
}

.breadcrumbs__list {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  flex-wrap: wrap;
  gap: 0;
}

.breadcrumbs__item {
  display: flex;
  align-items: center;
}

.breadcrumbs__sep {
  color: var(--color-border-md);
  padding: 0 6px;
}

.breadcrumbs__link {
  font-size: 0.75rem;
  font-weight: var(--font-weight-light);
  color: var(--color-muted);
  letter-spacing: 0.04em;
  transition: color var(--transition-fast);
  white-space: nowrap;
}

.breadcrumbs__link:hover {
  color: var(--color-black);
}

.breadcrumbs__current {
  font-size: 0.75rem;
  font-weight: var(--font-weight-normal);
  color: var(--color-black);
  letter-spacing: 0.04em;
  white-space: nowrap;
}

@media (max-width: 640px) {
  .breadcrumbs__inner {
    height: 40px;
  }
}
</style>
